export default {
  SET_COUNTRIES_DATA (state, data) {
    let countries = []
    if (Array.isArray(data) && data.length > 0) {
      countries = data
        .filter(c => c.id !== null)
        .map(c => ({ text: c.text, value: c.id }))
    }
    state.countries = countries
    localStorage.setItem('edit/countries', JSON.stringify(countries))
  },
  SET_CITIES_BY_COUNTRY_DATA (state, data) {
    let cities = []
    if (Array.isArray(data) && data.length > 0) {
      cities = data
        .filter(c => c.code !== null)
        .map(c => ({ text: c.name, value: c.code }))
    }
    state.citiesByCountry = cities
  }
}
